
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"74","height":"74"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('filter',{attrs:{"id":"a","x":"0","y":"0","width":"74","height":"74","filterUnits":"userSpaceOnUse"}},[_c('feOffset',{attrs:{"dy":"3"}}),_c('feGaussianBlur',{attrs:{"stdDeviation":"3","result":"blur"}}),_c('feFlood',{attrs:{"flood-opacity":".161"}}),_c('feComposite',{attrs:{"operator":"in","in2":"blur"}}),_c('feComposite',{attrs:{"in":"SourceGraphic"}})])]),_c('g',{attrs:{"data-name":"그룹 931"}},[_c('g',{attrs:{"filter":"url(#a)"}},[_c('g',{attrs:{"data-name":"타원 116","transform":"translate(9 6)","fill":"#fff","stroke":"#e66a1f","stroke-width":"3"}},[_c('circle',{attrs:{"cx":"28","cy":"28","r":"28","stroke":"none"}}),_c('circle',{attrs:{"cx":"28","cy":"28","r":"26.5","fill":"none"}})])]),_c('text',{attrs:{"transform":"translate(37 41)","fill":"#e66a1f","font-size":"16","font-family":"NotoSansCJKkr-Medium, Noto Sans CJK KR","font-weight":"500"}},[_c('tspan',{attrs:{"x":"-14.72","y":"0"}},[_v('신청')])])])])
          )
        }
      }
    